import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { useCloseConfirm } from '../../Form'
import {
  MINIMIZED_MODAL_KEY,
  useMinimizableModal,
  useResizeModal,
} from '../../Modal'
import { REQUEST_MINIMIZED_REPLACE_CONFIRMATION } from '../Request.constants'
import {
  useRequestDraft,
  useRequestDraftCloseConfirmation,
} from '../Request.hooks'
import { RequestForm } from '../RequestForm'
import { RequestFormPopupContainer } from '../RequestFormPopupContainer'

import { QA_NAME_REQUEST_CREATION_MODAL } from './RequestFormModal.constants'

function RequestFormModal({
  minimizedModalScope,
  title = 'Modal.NewServiceRequestTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const { fullScreen, handleResizeModal } = useResizeModal()

  const { draftId, setDraft } = useRequestDraft()

  const closeConfirmation = useRequestDraftCloseConfirmation(setDraft)

  const { handleMinimize, isMinimized, setIsDirty } = useMinimizableModal({
    closeConfirmation,
    minimizeKey: MINIMIZED_MODAL_KEY.REQUEST_FORM,
    qaName: QA_NAME_REQUEST_CREATION_MODAL,
    replaceConfirmation: REQUEST_MINIMIZED_REPLACE_CONFIRMATION,
    scope: minimizedModalScope,
    sourceId: draftId,
    title: t(title),
    onClose,
  })

  return (
    <RequestForm
      {...restProps}
      FormContainer={RequestFormPopupContainer}
      containerProps={{
        hidden: isMinimized,
        isCloseConfirm,
        isFullScreen: isMobileScreenSize || fullScreen,
        modal,
        qaName: QA_NAME_REQUEST_CREATION_MODAL,
        setCloseConfirm,
        title,
        onClose,
        onIsDirtyChange: setIsDirty,
        onMinimize: handleMinimize,
        onResize: isMobileScreenSize ? undefined : handleResizeModal, // to switch off the resize button on responsive mode
      }}
      contentComponentProps={{
        isFullScreen: isMobileScreenSize || fullScreen,
      }}
      setModal={setModal}
      onCancel={handleClose}
    />
  )
}

export default RequestFormModal
